module.exports = __webpack_public_path__ + "img/stock-line.03488e60.svg";